import React from 'react';
import { MinimalPageLayout } from '../../components/page';

export default function NoAccess() {
    return (
        <MinimalPageLayout className="no-access">
            Geen toegang tot de PRA voor deze gebruiker.
        </MinimalPageLayout>
    );
}
